import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { ShiftDataService } from 'app/components/shift-data-analysis/shift-data.service';
import { DashboardService } from 'app/services/dashboard.service';
import configurationData from 'assets/configuration.json';
import { Location } from '@angular/common';

@Component({
    selector: 'classic-layout',
    templateUrl: './classic.component.html',
    styleUrls: ['./classic.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ClassicLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    public orgName = '';
    public siteName = '';
    islnt: boolean;
    rga_ksa:boolean ;
    croatiastateroad:boolean ;
    jhnsw  :boolean;
    seymour  :boolean;
    loggedInUser:any;
    isAdmin :boolean = false;
    panelName: string = "Dashboard";
    panelTooltip : string = "Switch to Admin Panel";
    masterSites :any[] = [];
    allSitesSelected:boolean = true;
    isRoadis:boolean = false;
    logoImagePlaceHolder:any = '';
    logoDimension:any = '';
    displayNotification:boolean = false;
    isNHAI : boolean = true;
    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private shiftDataService: ShiftDataService,
        public dashboardService: DashboardService,
        private router: Router,private location: Location
    ) {
        this.isAdmin = localStorage.getItem("isAdmin") === "true" ? true : false;
        this.panelName = this.isAdmin ? "Dashboard" : "Admin";
        this.panelTooltip = this.isAdmin ? 'Switch to Dashboard Panel' : 'Switch to Admin Panel';
        this.shiftDataService.getMasterSiteInfo();//commenting will cause selection issue in site dropdown
        this.shiftDataService.getAssetTypesInAssets();
        
        this.openSiteDropdown();
        let loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        this.displayNotification = configurationData.displayNotification[loggedInUser.org_id.toString()] === undefined ? 
        configurationData.displayNotification['default']  : configurationData.displayNotification[loggedInUser.org_id.toString()] ;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // localStorage.setItem('currentPage', 'SLA');
        this.loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        this.islnt = (this.loggedInUser.org_id === 1) ? true : false;

        this.rga_ksa = (this.loggedInUser.org_id === 215) ? true : false;
        //configuration files
        this.croatiastateroad = (this.loggedInUser.org_id === 221) ? true : false;
        this.jhnsw = (this.loggedInUser.org_id === 205) ? true : false;
        this.seymour = (this.loggedInUser.org_id === 258) ? true : false;
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
        let loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        if (loggedInUser) {
            this.orgName = loggedInUser.org_name === 'L&T' ? 'Project' : this.dashboardService.translate(
                loggedInUser.org_name
            ).replaceAll('_',' ');
            this.siteName = this.shiftDataService.selectedMasterSite?.site_name?.replaceAll('_',' ');
        }
        this.isRoadis = (this.loggedInUser.user_roles.split(',').includes('ADMIN'))? true : false;
        this.shiftDataService.masterSiteSelectionChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.siteName =
                    this.shiftDataService.selectedMasterSite.site_name?.replaceAll('_',' ');
                    this.openSiteDropdown();
            });
            this.shiftDataService.masterSiteSelection
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.siteName =
                    this.shiftDataService.selectedMasterSite.site_name?.replaceAll('_',' ');
            });
        this.logoDimension = configurationData.logo_dimension[this.loggedInUser.org_id.toString()] === undefined ? configurationData.logo_dimension["default"] : 
        configurationData.logo_dimension[this.loggedInUser.org_id.toString()];
        this.logoImagePlaceHolder = configurationData.logo[this.loggedInUser.org_id.toString()] === undefined ? configurationData.logo["default"] : 
        configurationData.logo[this.loggedInUser.org_id.toString()];
        this.isNHAI = (this.loggedInUser.org_id === 303) ? false : true;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
        this.shiftDataService.windowSizeChanged.emit();
    }

    openRequestedPanel(){
        this.isAdmin = !this.isAdmin;
        localStorage.setItem("isAdmin",this.isAdmin.toString())
        if(this.isAdmin){
            this.router.navigate(['/department']); 
        }
        else{
            this.router.navigate(['/dashboard']); 
        //     this.router.navigate(['/dashboard']).then(() => {
        //     if (window.location.search) {
        //         this.location.replaceState(window.location.pathname);
        //     }
        // }); 
        }
    }

    openSiteDropdown(){
        // this.dashboardService.clearAllCache().subscribe(
        //     (res: any) => {  
        //         if(res.responseStatus.statusCode === 200){
        // this.dashboardService.getMasterSiteInfo().subscribe(
        //     (res: any) => {
                let allSiteDetails : any = localStorage.getItem("all-site-details");
                if(allSiteDetails != null && allSiteDetails !== "null" && allSiteDetails !== undefined){
                    allSiteDetails = JSON.parse(allSiteDetails);
                // }
                this.masterSites = allSiteDetails;
                this.masterSites = this.masterSites.map((site) => site[0]);
                this.shiftDataService.sitesCount = this.masterSites.length;
                // this.shiftDataService.selectedSite = [];
                this.masterSites.sort((a, b) =>
                    a.site_name > b.site_name ? 1 : -1
                );
                let sites :any = [];
                let all_sites_ids :any = [];
                this.masterSites.forEach((siteDetails) =>{
                    sites.push(siteDetails.site_name);
                    all_sites_ids.push(siteDetails.sub_sites[0].site_id);
                })
                this.shiftDataService.departmentDisplayEvent.emit();
                // localStorage.setItem("all-site-details",JSON.stringify(this.masterSites));
                localStorage.setItem("all_sites_ids",all_sites_ids);
                localStorage.setItem("allSites",sites);
                if(this.shiftDataService.selectedSite && this.shiftDataService.selectedSite.length === 0){
                    let data :any = localStorage.getItem("adminSelectedSites");
                    if(data != null && data !== "null"){
                        const resultArray = data.split(',');
                        this.shiftDataService.selectedSite = resultArray;
                        localStorage.setItem("adminSelectedSites",resultArray);
                    }
                }
                let data :any = localStorage.getItem("adminSelectedSites");
                    if(data === null || data === "null"){
                        let data :any = localStorage.getItem("allSites");
                        const resultArray = data.split(',');
                        this.shiftDataService.selectedSite = resultArray;
                        localStorage.setItem("adminSelectedSites",data);
                    }
    }
        //     },
        //     (error) => {}
        // );
        // }});
    }
    // selectedSite :any[]= ["AMTL"];
    isChecked(site_name: any) {
        return !!this.shiftDataService.selectedSite.filter(
            (a) => a == site_name
        ).length;
    }

    changeSite(site_name: any,menu:any){
        
        let val = this.shiftDataService.selectedSite.includes(site_name);
        if(!val){
            this.shiftDataService.selectedSite.push(site_name);
        }
        else{
            this.shiftDataService.selectedSite = this.shiftDataService.selectedSite.filter(item => item !== site_name);
        }   
        let selectedSite :any = this.shiftDataService.selectedSite;
        localStorage.setItem("adminSelectedSites",selectedSite);  
        this.allSitesSelected = this.shiftDataService.selectedSite.length === this.shiftDataService.sitesCount ? true: false;
    }

    siteSelectionChanged(event :any){
        
        if(event.checked){
            this.allSitesSelected = true;
            this.masterSites.forEach((siteDetails) =>{
               let val = this.shiftDataService.selectedSite.includes(siteDetails.site_name);
                if(!val){
                    this.shiftDataService.selectedSite.push(siteDetails.site_name);
                }
            })
        }
        else{
            this.allSitesSelected = false;
            this.shiftDataService.selectedSite = [];
        }
        let siteIds :any =  [];
        this.masterSites.forEach((siteDetails) =>{
            siteIds.push(siteDetails.site_name);
         })
        localStorage.setItem("adminSelectedSites",siteIds);
        let selectedSite :any = this.shiftDataService.selectedSite;
        // localStorage.setItem("adminSelectedSites",selectedSite);  
        // if(!this.allSitesSelected){
        //     this.allSitesSelected = true;
        //     this.masterSites.forEach((siteDetails) =>{
        //        let val = this.shiftDataService.selectedSite.includes(siteDetails.site_name);
        //         console.log(val);
        //         if(!val){
        //             this.shiftDataService.selectedSite.push(siteDetails.site_name);
        //         }
        //     })
        // }
    }

    onMenuClosed(){
        if(this.shiftDataService.selectedSite.length === 0){
            this.masterSites.forEach((siteDetails) =>{
                this.shiftDataService.selectedSite.push(siteDetails.site_name);
            })
            this.allSitesSelected = true;
        }
        this.shiftDataService.selectedAssetIds = [];
        this.shiftDataService.siteChangeEvent.emit();
    }

    openMatmenu(){
        if(this.shiftDataService.selectedSite.length === 0){
            this.masterSites.forEach((siteDetails) =>{
                this.shiftDataService.selectedSite.push(siteDetails.site_name);
            })
            this.allSitesSelected = true;
        }
        else if(this.shiftDataService.selectedSite.length === this.shiftDataService.sitesCount){
            this.allSitesSelected = true;
        }
        else{
            this.allSitesSelected = false;
        }
    }
}
